import * as React from "react"

import { cn } from "@/lib/utils"

function Input({
  className,
  type,
  ...props
}) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "[color:var(--neutral-700)] [background-color:var(--neutral-50)] border border-(--neutral-300) rounded-md px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none h-9 w-full min-w-0 file:text-[var(--color-card-foreground)] placeholder:text-[var(--color-muted-foreground)] selection:bg-(--color-primary) selection:text-[var(--color-primary-foreground)] disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "focus-visible:border-[var(--color-ring)] focus-visible:ring-[var(--color-ring)]/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-[var(--color-destructive)]/20 dark:aria-invalid:ring-[var(--color-destructive)]/40 aria-invalid:border-(--color-destructive)",
        className
      )}
      {...props} />
  );
}

export { Input }
